import axios from 'axios';

class ExpirationService {
  async getExpirationDates() {
    try {
      const response = await axios.get('/expiration-dates.json');
      return response.data;
    } catch (error) {
      console.error('Error loading expiration dates:', error);
      return {
        lastUpdated: new Date().toISOString(),
        expirations: []
      };
    }
  }

  checkForExpiringItems(expirations, warningDays = 7) {
    if (!expirations || expirations.length === 0) {
      return [];
    }

    const now = new Date();
    const warningThreshold = new Date();
    warningThreshold.setDate(now.getDate() + warningDays);

    return expirations.filter(item => {
      const expirationDate = new Date(item.expirationDate);
      return expirationDate <= warningThreshold;
    });
  }

  calculateDaysRemaining(expirationDateStr) {
    const now = new Date();
    const expirationDate = new Date(expirationDateStr);
    const diffTime = expirationDate - now;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }
}

export default new ExpirationService();